import { PaymentMethodsWithConfig } from "@/components/PaymentMethods";
import { EventName } from "@/types/Events";
import { DetailsStep } from "@/types/Navigation";
import { dispatchEvent } from "@/utils/event-dispacher";

type FormStepPaymentProps = {
  onStepSubmit: () => void;
};

export function FormStepPayment(props: FormStepPaymentProps) {
  const { onStepSubmit } = props;

  const handlePaymentSuccess = (paymentMethod: string) => {
    dispatchEvent(EventName.STEP_SUBMIT, {
      step_name: DetailsStep.PaymentType,
      data: {
        payment_method: paymentMethod,
      },
    });
    onStepSubmit();
  };

  return <PaymentMethodsWithConfig onPaymentSuccess={handlePaymentSuccess} />;
}
